/* istanbul ignore file */
export enum SortOrder {
  Ascending = "asc",
  Descending = "desc"
}
